export const testimonials: TestimonialListingCard[] = [
  {
    authorDesignation: 'CMO',
    authorName: 'Kieran Flanagan',
    company: 'Zapier',
    review:
      'Pepper Content is the hidden gem! You can create content with AI and hire the top 3% of freelance talent. The AI can tell you what keywords are relevant, and the AI can create the first draft which is then shared with editors, and everything is managed in this one cool platform!',
    authorImage: {
      data: {
        id: '1',
        attributes: {
          height: 400,
          width: 400,
          name: 'Kieran Flanagan',
          url: '/assets/order/images/Kieran_Flanagan.jpeg'
        }
      }
    }
  },
  {
    authorDesignation: 'CMO',
    authorName: 'Kipp Bodnar',
    company: 'Hubspot',
    review:
      'Pepper Content brings AI and humans together in a really interesting way that helps you go to market and tell your stories faster!',
    authorImage: {
      data: {
        id: '1',
        attributes: {
          height: 400,
          width: 400,
          name: 'Kipp Bodnar',
          url: '/assets/order/images/Kipp_Bodnar.jpeg'
        }
      }
    }
  }
]
